// removed by extract-text-webpack-plugin
module.exports = {"technologies_block":"technologies_block","technologies_block_wrapper":"technologies_block_wrapper"};


//////////////////
// WEBPACK FOOTER
// ./src/view/screens/Project/components/TechnologiesBlock/style.scss
// module id = 1363
// module chunks = 0